import type { ComponentPropsWithoutRef, ReactNode, Ref } from 'react'

import { cn } from '@gto/ui/cn'
import { HelpIconTooltip } from '@gto/ui/components/help-icon-tooltip'

import { groupedFieldVariants } from './grouped-field.styles'

export type GroupedFieldLegendProps = ComponentPropsWithoutRef<'legend'> & {
  /** Legend content for the grouped controls. */
  children?: ReactNode
  /** Optional help tooltip rendered next to the legend. */
  tooltip?: ReactNode
  /** Additional CSS class names. */
  className?: string
  /** React 19 ref prop. */
  ref?: Ref<HTMLLegendElement>
}

export const Legend = ({
  children,
  className,
  tooltip,
  ref,
  ...props
}: GroupedFieldLegendProps) => {
  const { legend } = groupedFieldVariants()

  return (
    <legend
      ref={ref}
      className={cn(legend(), className)}
      {...props}
    >
      {children}
      {tooltip !== undefined && (
        <HelpIconTooltip
          embedded
          content={tooltip}
        />
      )}
    </legend>
  )
}
